
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {authModule, certificatesModule, certificatesState} from '@/utils/store-acessor';
  import {CertificateModel} from '@/models/certificate.model';
  import CollaborationCertificate from '@/components/certificates/CollaborationCertificate.vue';

  @Component({
    components: {
      CollaborationCertificate
    },
    metaInfo() {
      return {
        title: 'Ikone'
      };
    },
  })
  export default class VerifyCertificate extends Vue {
    @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
    @certificatesModule.Getter('certificate') certificate!: CertificateModel;

    mounted() {
      certificatesState.findByVerifyCode(this.$route.params?.verifyCode);
    }
  }
